import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL_BASE } from 'app/core/constants';
import { HttpUtils } from 'app/shared/http-utils';
import { Observable } from 'rxjs';
import { GlobalConfiguration } from './global-configuration.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GlobalConfigurationService {

  private apiUrl = `${URL_BASE}/api/global-configurations`;

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Array<GlobalConfiguration>> {
    const headers = HttpUtils.createHeaders();

    return this.http.get(this.apiUrl, { headers })
      .pipe(
        map((result: any[]) => result.map(e => GlobalConfiguration.fromDto(e)))
      );
  }

  public create(globalConfiguration: GlobalConfiguration): Observable<GlobalConfiguration> {
    const headers = HttpUtils.createHeaders();

    return this.http.post(this.apiUrl, GlobalConfiguration.toDto(globalConfiguration), { headers })
      .pipe(
        map(gc => GlobalConfiguration.fromDto(gc))
      );
  }

  public update(globalConfiguration: GlobalConfiguration): Observable<GlobalConfiguration> {
    const headers = HttpUtils.createHeaders();

    const url = `${this.apiUrl}/${globalConfiguration.id}`;

    return this.http.put(url, GlobalConfiguration.toDto(globalConfiguration), { headers })
      .pipe(
        map(gc => GlobalConfiguration.fromDto(gc))
      );
  }

  public delete(id: string): Observable<void> {
    const headers = HttpUtils.createHeaders();

    const url = `${this.apiUrl}/${id}`;

    return this.http.delete<void>(url, { headers });
  }
}
